export { pol_nl, pol_de_nl, pol_na, pol_as, pol_aus, pol_europe, pol_de_rough, pol_fr_rough, pol_uk_rough, pol_be_rough, pol_sc_rough, pol_es_rough };

const pol_na = {
  coordinates: [
    [-57.5917877, 83.111071],
    [-57.4849619, 83.153111],
    [-77.5344777, 83.676943],
    [-136.9795335, 73.3278581],
    [-166.526005, 71.3007929],
    [-167.8450521, 67.0674334],
    [-171.2745745, 64.3208716],
    [-189.6719575, 52.908902],
    [-166.7586378, 22.4313402],
    [-155.7085809, 17.7277586],
    [-117.7491839, 32.1011897],
    [-114.8033121, 32.2499745],
    [-109.0874413, 31.052934],
    [-106.0976012, 30.9399243],
    [-103.5034753, 28.7676591],
    [-101.3050635, 29.2672329],
    [-99.6923771, 27.3229749],
    [-99.1190019, 26.234302],
    [-97.211043, 25.6415264],
    [-84.1085085, 24.4871486],
    [-67.9721657, 20.3034175],
    [-68.0601021, 16.8886598],
    [-64.1029609, 17.0567846],
    [-72.1892422, 36.7388841],
    [-50.7327428, 46.6795945],
    [-59.3505172, 58.6312166],
    [-59.1746442, 67.6092206],
    [-76.7619388, 74.4493575],
    [-69.727021, 79.7499321],
    [-63.3955949, 81.4923058],
  ],

  type: "LineString",
};

const pol_de_nl = {
  coordinates: [
    [8.0639648, 55.0846559],
    [7.4816895, 53.9625494],
    [4.5703125, 53.2914891],
    [3.0487061, 51.566827],
    [3.3947754, 51.2344074],
    [3.515625, 51.2344074],
    [3.8012695, 51.2077438],
    [3.8857269, 51.1987091],
    [3.9440918, 51.1999998],
    [4.4219971, 51.3580616],
    [4.5895386, 51.428327],
    [5.2294922, 51.2653521],
    [5.8117676, 51.1173168],
    [5.6414795, 50.8718448],
    [5.6387329, 50.8510411],
    [5.6404495, 50.8306619],
    [5.6813049, 50.7560067],
    [6.1853027, 50.6250731],
    [6.1619568, 50.5448539],
    [6.3446045, 50.3822539],
    [6.1660767, 50.2296379],
    [6.1303711, 50.1725005],
    [6.1248779, 50.1311432],
    [6.1029053, 50.018329],
    [6.1633301, 49.9688893],
    [6.2374878, 49.8955191],
    [6.3226318, 49.8379825],
    [6.4929199, 49.7599775],
    [6.3336182, 49.5679779],
    [6.3830566, 49.4431288],
    [6.7346191, 49.1457836],
    [8.1518555, 48.9621874],
    [7.8607178, 48.6800808],
    [7.7398682, 48.5056871],
    [7.5585938, 48.0817489],
    [7.5091553, 47.8279082],
    [7.5064087, 47.6820321],
    [7.5723267, 47.5413096],
    [7.691803, 47.5301838],
    [8.1188965, 47.5301838],
    [8.4347534, 47.5598473],
    [8.5803223, 47.5802313],
    [8.7698364, 47.6635376],
    [8.9099121, 47.6339328],
    [9.0966797, 47.656138],
    [10.0827026, 47.3816142],
    [10.1173782, 47.3171812],
    [10.1870728, 47.256864],
    [10.4631042, 47.3490586],
    [10.645752, 47.5413096],
    [10.9698486, 47.3890526],
    [11.2884521, 47.4020674],
    [12.2113037, 47.6024593],
    [13.0023193, 47.4652362],
    [13.1121826, 47.5320382],
    [13.1176758, 47.639485],
    [12.8649902, 48.1514281],
    [13.3154297, 48.2978125],
    [13.8427734, 48.5566141],
    [13.8867188, 48.7561888],
    [13.7823486, 48.8827796],
    [13.0627441, 49.317961],
    [12.6672363, 49.4895385],
    [12.5738525, 49.908787],
    [12.3486328, 50.1698617],
    [14.8754883, 50.8406358],
    [15.0622559, 51.2687892],
    [14.9963379, 51.467697],
    [14.7766113, 51.6316573],
    [14.7628784, 52.0609346],
    [14.680481, 52.569673],
    [14.1668701, 52.8774186],
    [14.3453979, 53.047818],
    [14.5019531, 53.230701],
    [13.9855957, 54.9334543],
    [8.0529785, 55.0846559],
  ],

  type: "LineString",
};

const pol_nl = {
  coordinates: [
    [6.3336182, 53.7454624],
    [5.7897949, 53.6674258],
    [4.7460938, 53.4324467],
    [4.3341064, 53.0213922],
    [4.2132568, 52.4258727],
    [3.081665, 51.5702414],
    [3.3556366, 51.3743522],
    [3.3583832, 51.315593],
    [3.3776093, 51.2769511],
    [3.4449005, 51.2412858],
    [3.5279846, 51.2455843],
    [3.5163116, 51.2859704],
    [3.581543, 51.2876882],
    [3.5952759, 51.3022867],
    [3.7875366, 51.2473035],
    [3.7899399, 51.2118303],
    [3.8853836, 51.2008603],
    [3.9605713, 51.2163466],
    [4.0594482, 51.2438649],
    [4.1679382, 51.2902647],
    [4.2420959, 51.3520583],
    [4.2269897, 51.3734949],
    [4.3347931, 51.3777811],
    [4.3402863, 51.3580616],
    [4.4316101, 51.3627779],
    [4.4316101, 51.3752094],
    [4.3938446, 51.4210484],
    [4.4007111, 51.453579],
    [4.5222473, 51.4809553],
    [4.5346069, 51.4231893],
    [4.6671295, 51.4249019],
    [4.7673798, 51.502759],
    [4.836731, 51.4728297],
    [4.7660065, 51.4304675],
    [4.7701263, 51.4146251],
    [4.7886658, 51.4086293],
    [4.9198151, 51.3944931],
    [5.0042725, 51.4437367],
    [5.0440979, 51.4715465],
    [5.1031494, 51.4317518],
    [5.0708771, 51.3944931],
    [5.1347351, 51.3177388],
    [5.1622009, 51.3117303],
    [5.2363586, 51.3048624],
    [5.2267456, 51.2687892],
    [5.2349854, 51.2619149],
    [5.4190063, 51.2610555],
    [5.5110168, 51.2936999],
    [5.5577087, 51.2249478],
    [5.8145142, 51.1190409],
    [5.6387329, 50.8579767],
    [5.6510925, 50.8267585],
    [5.6936646, 50.8059347],
    [5.6826782, 50.7573099],
    [6.0218811, 50.7538347],
    [6.0747528, 50.8467059],
    [6.0877991, 50.8718448],
    [6.0932922, 50.9190519],
    [6.0273743, 50.9835054],
    [5.9545898, 51.0362128],
    [6.1743164, 51.1603994],
    [6.1811829, 51.1870904],
    [6.1042786, 51.25418],
    [6.2265015, 51.3606342],
    [6.2278748, 51.3983489],
    [6.2127686, 51.5155798],
    [6.1166382, 51.6563708],
    [6.0424805, 51.7176703],
    [5.9902954, 51.7686897],
    [6.0095215, 51.8366261],
    [6.16745, 51.8406566],
    [6.1880493, 51.8790343],
    [6.3075256, 51.8502011],
    [6.4050293, 51.8281396],
    [6.4984131, 51.8612277],
    [6.729126, 51.8993761],
    [6.8280029, 51.963731],
    [6.8293762, 51.9924914],
    [6.6920471, 52.0550239],
    [6.8527222, 52.1225282],
    [7.064209, 52.2412561],
    [7.0751953, 52.3655376],
    [6.9873047, 52.4610302],
    [6.7730713, 52.5579859],
    [7.0367432, 52.6330629],
    [7.2235107, 53.0048679],
    [7.2015381, 53.330873],
    [6.913147, 53.3456326],
    [6.8994141, 53.434083],
    [6.5643311, 53.5810921],
    [6.3466644, 53.7261699],
    [6.3335323, 53.7454624],
  ],
  type: "LineString",
};

const pol_as = {
  coordinates: [
    [144.0527344, 45.9511497],
    [149.0625, 43.0688878],
    [144.84375, 34.2345124],
    [133.1542969, 25.244696],
    [122.2558594, 19.5597901],
    [115.8398437, 21.9430455],
    [122.34375, 28.459033],
    [123.0908203, 35.7821707],
    [131.4404297, 39.6902806],
    [139.7460937, 45.9511497],
    [144.0307617, 45.9664245],
  ],
  type: "LineString",
};

const pol_aus = {
  coordinates: [
    [108.28125, -18.1458518],
    [119.3554687, -11.6952727],
    [132.1875, -9.4490618],
    [145.4589844, -10.2284373],
    [158.1152344, -20.3034175],
    [154.1601562, -45.2748864],
    [107.7539062, -43.7710938],
    [108.4570312, -17.8951143],
  ],
  type: "LineString",
};

const pol_fr_rough = {
  "coordinates": [

    [
      6.3648605, 49.4690165
    ],
    [
      6.26214, 49.5168209
    ],
    [
      5.8062744, 49.5786644
    ],
    [
      5.0726151, 49.7891194
    ],
    [
      4.8803544, 50.1530225
    ],
    [
      4.6935868, 50.1495026
    ],
    [
      4.6496415, 50.0155576
    ],
    [
      4.3200517, 49.9979054
    ],
    [
      4.1662431, 50.314654
    ],
    [
      3.7377763, 50.3952644
    ],
    [
      3.627913, 50.514177
    ],
    [
      3.325789, 50.5525847
    ],
    [
      3.1555009, 50.8136227
    ],
    [
      2.8478837, 50.7476304
    ],
    [
      2.3425126, 51.2798369
    ],
    [
      1.9101564, 51.1824502
    ],
    [
      1.2062169, 50.8307703
    ],
    [
      1.1662096, 50.1470964
    ],
    [
      0.2735484, 49.9628714
    ],
    [
      -0.1236427, 49.8044247
    ],
    [
      -0.1903853, 49.5922974
    ],
    [
      -0.9087225, 49.5957468
    ],
    [
      -1.0404121, 49.8378164
    ],
    [
      -1.4305474, 49.8658188
    ],
    [
      -2.1348571, 49.8841831
    ],
    [
      -2.1154761, 49.535765
    ],
    [
      -1.8368085, 49.2553415
    ],
    [
      -2.0057075, 48.9012893
    ],
    [
      -2.4977324, 48.9530856
    ],
    [
      -2.6107446, 49.2242122
    ],
    [
      -2.9267377, 49.2900342
    ],
    [
      -3.071355, 49.2781647
    ],
    [
      -5.3140749, 48.6303559
    ],
    [
      -5.3421595, 48.3752949
    ],
    [
      -5.3089145, 47.9114522
    ],
    [
      -4.2734017, 47.4762018
    ],
    [
      -3.5375977, 47.1739615
    ],
    [
      -2.8048177, 47.0764935
    ],
    [
      -2.6495505, 46.6117146
    ],
    [
      -1.8225288, 46.172639
    ],
    [
      -1.5041837, 44.6459715
    ],
    [
      -1.8077472, 43.5528715
    ],
    [
      -1.7816042, 43.3448897
    ],
    [
      -1.7310372, 43.2963004
    ],
    [
      -1.6540185, 43.2977528
    ],
    [
      -1.6141838, 43.2569244
    ],
    [
      -1.571118, 43.2454997
    ],
    [
      -1.4443697, 43.260417
    ],
    [
      -1.3870789, 43.2169286
    ],
    [
      -1.4764191, 43.0974655
    ],
    [
      -1.4399958, 43.0425629
    ],
    [
      -1.3634608, 43.0286904
    ],
    [
      -1.275965, 43.0364465
    ],
    [
      -0.9035296, 42.9426012
    ],
    [
      -0.7498271, 42.9575218
    ],
    [
      -0.7232793, 42.887395
    ],
    [
      -0.541962, 42.7813385
    ],
    [
      -0.2656247, 42.8193761
    ],
    [
      -0.0184593, 42.6844308
    ],
    [
      0.1543431, 42.7176251
    ],
    [
      0.2932201, 42.671574
    ],
    [
      0.6734626, 42.6904008
    ],
    [
      0.7251561, 42.8496431
    ],
    [
      0.9441308, 42.7829921
    ],
    [
      1.0513884, 42.7772043
    ],
    [
      1.1803427, 42.7047043
    ],
    [
      1.3434905, 42.6968196
    ],
    [
      1.4444826, 42.604913
    ],
    [
      1.5163753, 42.6501218
    ],
    [
      1.5852481, 42.6356557
    ],
    [
      1.7058619, 42.6204679
    ],
    [
      1.7398377, 42.5901521
    ],
    [
      1.7311439, 42.4923921
    ],
    [
      1.9370533, 42.4291961
    ],
    [
      1.9690061, 42.374394
    ],
    [
      2.0131074, 42.343473
    ],
    [
      2.0829239, 42.3609579
    ],
    [
      2.1237904, 42.383215
    ],
    [
      2.1525377, 42.4169817
    ],
    [
      2.1825178, 42.4185896
    ],
    [
      2.206831, 42.4166946
    ],
    [
      2.2552235, 42.4328269
    ],
    [
      2.2908935, 42.4203598
    ],
    [
      2.3463288, 42.4055136
    ],
    [
      2.4291463, 42.3833477
    ],
    [
      2.4332401, 42.3775088
    ],
    [
      2.4793873, 42.3392541
    ],
    [
      2.5412887, 42.3335697
    ],
    [
      2.5574098, 42.3466607
    ],
    [
      2.5752356, 42.3543935
    ],
    [
      2.6217025, 42.3431042
    ],
    [
      2.6573841, 42.3395535
    ],
    [
      2.676418, 42.3421328
    ],
    [
      2.6720571, 42.3874348
    ],
    [
      2.6731414, 42.3999125
    ],
    [
      2.7547465, 42.4197202
    ],
    [
      2.7679183, 42.4055512
    ],
    [
      2.7849369, 42.4136332
    ],
    [
      2.8456594, 42.4522562
    ],
    [
      2.8975933, 42.4582861
    ],
    [
      2.9464829, 42.4651088
    ],
    [
      3.0372939, 42.4646101
    ],
    [
      3.0728321, 42.431162
    ],
    [
      3.1729153, 42.4327141
    ],
    [
      3.4473937, 42.4358419
    ],
    [
      3.2902394, 42.8216268
    ],
    [
      3.4471571, 43.0430804
    ],
    [
      4.0364002, 43.2496103
    ],
    [
      5.4872737, 42.929908
    ],
    [
      6.1012677, 42.7569702
    ],
    [
      6.6390956, 42.8250892
    ],
    [
      6.8339438, 43.0112374
    ],
    [
      7.0092155, 43.23104
    ],
    [
      7.3530668, 43.4074794
    ],
    [
      8.3158305, 42.4720653
    ],
    [
      8.2554953, 41.8866239
    ],
    [
      8.7830358, 41.2623561
    ],
    [
      9.2357159, 41.3119199
    ],
    [
      9.6143094, 41.4776537
    ],
    [
      9.8568989, 42.288834
    ],
    [
      9.5895901, 43.1749506
    ],
    [
      7.6792769, 43.623153
    ],
    [
      7.5633639, 43.7115642
    ],
    [
      7.5245271, 43.8064967
    ],
    [
      7.5063069, 43.8721582
    ],
    [
      7.5659812, 43.8977803
    ],
    [
      7.580052, 43.9356693
    ],
    [
      7.6711856, 43.9878396
    ],
    [
      7.7170408, 44.0728604
    ],
    [
      7.6830139, 44.1742017
    ],
    [
      7.3825009, 44.1374159
    ],
    [
      7.2416527, 44.1773066
    ],
    [
      7.1083927, 44.2225795
    ],
    [
      6.9667197, 44.3120805
    ],
    [
      6.9460894, 44.4259612
    ],
    [
      6.8863411, 44.5150069
    ],
    [
      6.9342521, 44.5792996
    ],
    [
      7.0746128, 44.6780983
    ],
    [
      7.0559707, 44.7155137
    ],
    [
      7.0312386, 44.7545355
    ],
    [
      7.0329562, 44.8330782
    ],
    [
      6.8170639, 44.887955
    ],
    [
      6.7538523, 45.007535
    ],
    [
      6.665431, 45.0870055
    ],
    [
      6.7402706, 45.1296363
    ],
    [
      6.9082921, 45.137311
    ],
    [
      7.1376188, 45.2244984
    ],
    [
      7.1878123, 45.4065253
    ],
    [
      7.0226848, 45.5354157
    ],
    [
      6.995947, 45.636847
    ],
    [
      6.8223648, 45.7450062
    ],
    [
      6.8682177, 45.815857
    ],
    [
      6.9414887, 45.8397354
    ],
    [
      6.9953956, 45.8575815
    ],
    [
      7.0431231, 45.9247071
    ],
    [
      7.0200761, 45.9969244
    ],
    [
      6.9289819, 46.0661444
    ],
    [
      6.895434, 46.0806508
    ],
    [
      6.9057525, 46.1231283
    ],
    [
      6.8115782, 46.1454772
    ],
    [
      6.8189399, 46.2060026
    ],
    [
      6.8579985, 46.2463505
    ],
    [
      6.8647056, 46.2893749
    ],
    [
      6.804248, 46.33381
    ],
    [
      6.8141426, 46.4300412
    ],
    [
      6.5319765, 46.4516074
    ],
    [
      6.2895329, 46.386121
    ],
    [
      6.2352806, 46.3083213
    ],
    [
      6.2814921, 46.2192548
    ],
    [
      6.1956791, 46.2012355
    ],
    [
      6.164172, 46.1512674
    ],
    [
      6.0028826, 46.1516985
    ],
    [
      5.9832754, 46.2132416
    ],
    [
      6.1305863, 46.2477602
    ],
    [
      6.1173044, 46.2934523
    ],
    [
      6.1751226, 46.3701923
    ],
    [
      6.0789518, 46.4178015
    ],
    [
      6.1672844, 46.5420966
    ],
    [
      6.1308285, 46.5797855
    ],
    [
      6.3924792, 46.7309191
    ],
    [
      6.4732751, 46.7873962
    ],
    [
      6.4725434, 46.93929
    ],
    [
      6.686023, 47.0206568
    ],
    [
      7.0249247, 47.3052877
    ],
    [
      7.0580852, 47.3582096
    ],
    [
      6.9435751, 47.4039264
    ],
    [
      7.0094858, 47.473301
    ],
    [
      7.1186396, 47.4925733
    ],
    [
      7.176039, 47.4413754
    ],
    [
      7.3047746, 47.4121748
    ],
    [
      7.4172758, 47.4477969
    ],
    [
      7.5930883, 47.5782537
    ],
    [
      7.5891605, 47.5899095
    ],
    [
      7.5247899, 47.6566601
    ],
    [
      7.5113949, 47.6993683
    ],
    [
      7.5542888, 47.8780918
    ],
    [
      7.5664312, 48.0329053
    ],
    [
      7.5810063, 48.1227528
    ],
    [
      7.7144811, 48.3490034
    ],
    [
      7.8031254, 48.5869271
    ],
    [
      7.8546131, 48.6460314
    ],
    [
      7.9738319, 48.7590745
    ],
    [
      8.068825, 48.8174472
    ],
    [
      8.1972063, 48.9627016
    ],
    [
      8.0225623, 49.002048
    ],
    [
      7.6469994, 49.0427348
    ],
    [
      7.5063121, 49.0926912
    ],
    [
      7.4539769, 49.1549555
    ],
    [
      7.401309, 49.1713511
    ],
    [
      7.3572564, 49.1395652
    ],
    [
      7.2912633, 49.1049353
    ],
    [
      7.1972895, 49.1091355
    ],
    [
      7.1029294, 49.1311838
    ],
    [
      7.0397258, 49.1002783
    ],
    [
      7.017391, 49.1835793
    ],
    [
      6.9474792, 49.2004264
    ],
    [
      6.8884277, 49.2045886
    ],
    [
      6.8620589, 49.1772148
    ],
    [
      6.8458343, 49.1510206
    ],
    [
      6.7286915, 49.1626541
    ],
    [
      6.7218089, 49.2171556
    ],
    [
      6.6721237, 49.2811078
    ],
    [
      6.5991676, 49.3643493
    ],
    [
      6.5583551, 49.4160024
    ],
    [
      6.4905059, 49.4593521
    ],
    [
      6.4650015, 49.4664385
    ],
    [
      6.4447508, 49.4677741
    ],
    [
      6.4281097, 49.4768967
    ],
    [
      6.4197654, 49.4764174
    ],
    [
      6.4093644, 49.468869
    ],
    [
      6.3953747, 49.4646713
    ],
    [
      6.3800066, 49.46654
    ],
    [
      6.3726349, 49.466618
    ],
    [
      6.3715985, 49.4686357
    ],
    [
      6.3677251, 49.4693891
    ]

  ],
  "type": "LineString"
}
const pol_de_rough = {
  coordinates: [
    [6.3500977, 53.8265967],
    [7.8442383, 54.0980602],
    [8.0310059, 55.0972111],
    [8.4512329, 55.0626463],
    [8.555603, 54.9192499],
    [8.7451172, 54.8987389],
    [8.9208984, 54.9034703],
    [9.0802002, 54.8687048],
    [9.2422485, 54.8513153],
    [9.2504883, 54.8070089],
    [9.3411255, 54.8014755],
    [9.3754578, 54.8216573],
    [9.3768311, 54.837086],
    [9.4091034, 54.8423216],
    [9.4303894, 54.827191],
    [9.4866943, 54.8434044],
    [9.6075439, 54.8856905],
    [9.6350098, 54.8370767],
    [9.8245239, 54.819675],
    [10.5358887, 54.5847383],
    [11.3269043, 54.5975249],
    [11.9970703, 54.3805016],
    [13.3044434, 54.8577215],
    [13.9801025, 54.7214679],
    [14.2396545, 54.0069509],
    [14.2080688, 53.9075973],
    [14.2863464, 53.7698215],
    [14.2822266, 53.681253],
    [14.2877197, 53.6389372],
    [14.3193054, 53.6161365],
    [14.3138123, 53.581124],
    [14.3083191, 53.5525761],
    [14.3206787, 53.5158154],
    [14.3495178, 53.4978693],
    [14.3769836, 53.4029863],
    [14.4168091, 53.3243231],
    [14.4580078, 53.2556058],
    [14.4140625, 53.2093953],
    [14.3728638, 53.1962363],
    [14.3838501, 53.1418921],
    [14.3811035, 53.0940831],
    [14.3481445, 53.0445685],
    [14.2355347, 52.9883828],
    [14.1668701, 52.961921],
    [14.1421509, 52.9304309],
    [14.161377, 52.8923674],
    [14.1586304, 52.8675069],
    [14.1256714, 52.8359891],
    [14.213562, 52.8160729],
    [14.3536377, 52.7479472],
    [14.4195557, 52.6930432],
    [14.506073, 52.6501449],
    [14.5919037, 52.614721],
    [14.626236, 52.5884508],
    [14.6420288, 52.5721784],
    [14.6173096, 52.5429551],
    [14.6365356, 52.494653],
    [14.5870972, 52.4360782],
    [14.5404053, 52.3958705],
    [14.5843506, 52.3086181],
    [14.7106934, 52.253027],
    [14.7216797, 52.2295122],
    [14.7024536, 52.1823719],
    [14.7463989, 52.081219],
    [14.7601318, 52.0322809],
    [14.7244263, 52.0035453],
    [14.699707, 51.9002646],
    [14.6118164, 51.8391697],
    [14.647522, 51.7951088],
    [14.6914673, 51.7100316],
    [14.7491455, 51.6810933],
    [14.7683716, 51.6265558],
    [14.7299194, 51.5548773],
    [14.8068237, 51.5104523],
    [14.8919678, 51.4933563],
    [14.9606323, 51.4609056],
    [14.9853516, 51.3529131],
    [15.03479, 51.2859745],
    [15.0073242, 51.1260425],
    [14.8919678, 50.9325383],
    [14.8590088, 50.9112598],
    [14.8260498, 50.8883079],
    [14.81987, 50.8805106],
    [14.8267365, 50.8692486],
    [14.8027039, 50.818083],
    [14.7271729, 50.8198971],
    [14.6846008, 50.8362945],
    [14.6159363, 50.8571006],
    [14.6392822, 50.9221015],
    [14.5568848, 50.9168981],
    [14.5843506, 50.9826791],
    [14.4168091, 51.0190033],
    [14.2959595, 51.0362778],
    [14.2712402, 50.9947964],
    [14.3481445, 50.9844257],
    [14.4058228, 50.9325139],
    [14.3920898, 50.8996117],
    [14.3096924, 50.8822859],
    [14.2355347, 50.8788213],
    [14.213562, 50.8510791],
    [14.0734863, 50.8094375],
    [13.9498901, 50.7972889],
    [13.911438, 50.7434302],
    [13.8482666, 50.7225706],
    [13.7081909, 50.7138762],
    [13.5543823, 50.7068967],
    [13.543396, 50.6738529],
    [13.5131836, 50.6337954],
    [13.4555054, 50.5919774],
    [13.392334, 50.6233606],
    [13.3319092, 50.5954625],
    [13.3209229, 50.5710446],
    [13.2810974, 50.578026],
    [13.241272, 50.5762806],
    [13.2344055, 50.5562133],
    [13.2151794, 50.5274083],
    [13.1973267, 50.5047025],
    [13.1369019, 50.5038436],
    [13.0407715, 50.5047],
    [13.0270386, 50.4435324],
    [12.9418945, 50.3980295],
    [12.8347778, 50.4470437],
    [12.7276611, 50.4137875],
    [12.6974487, 50.3980332],
    [12.5299072, 50.3892779],
    [12.4447632, 50.3191656],
    [12.4035645, 50.2928541],
    [12.3664856, 50.2735474],
    [12.3362732, 50.2208524],
    [12.321167, 50.1593806],
    [12.1673584, 50.2929628],
    [12.1234131, 50.2472925],
    [12.2058105, 50.1769743],
    [12.2717285, 50.0713034],
    [12.4639893, 49.9760051],
    [12.5463867, 49.8946769],
    [12.4914551, 49.7919314],
    [12.3815918, 49.7351582],
    [12.4749756, 49.69964],
    [12.557373, 49.6071864],
    [12.6177979, 49.550244],
    [12.7276611, 49.4181787],
    [12.8869629, 49.3430756],
    [12.958374, 49.3287636],
    [13.0187988, 49.2857765],
    [13.1396484, 49.1889197],
    [13.2330322, 49.0990744],
    [13.2824707, 49.1206657],
    [13.3868408, 49.0450908],
    [13.4307861, 48.9874431],
    [13.5626221, 48.9585968],
    [13.694458, 48.8719406],
    [13.8208008, 48.7923902],
    [13.8592529, 48.6729545],
    [13.7878418, 48.5712733],
    [13.727417, 48.513082],
    [13.5296631, 48.5785629],
    [13.4637451, 48.5349152],
    [13.4417725, 48.4183632],
    [13.4143066, 48.3526958],
    [13.260498, 48.2723115],
    [13.0682373, 48.2650055],
    [12.8759766, 48.1734849],
    [12.7661133, 48.1148366],
    [12.8649902, 47.9899693],
    [12.958374, 47.9090216],
    [13.0187988, 47.827942],
    [12.925415, 47.7356508],
    [13.0133057, 47.7208779],
    [13.0957031, 47.6765045],
    [13.0737305, 47.5728207],
    [13.024292, 47.4615269],
    [12.8842163, 47.5079234],
    [12.7880859, 47.5691172],
    [12.7606201, 47.6469057],
    [12.6809692, 47.6746651],
    [12.5985718, 47.6339541],
    [12.4832153, 47.6246892],
    [12.2360229, 47.6931522],
    [12.1838379, 47.6987116],
    [12.2085571, 47.6450357],
    [12.1920776, 47.5969211],
    [12.0217896, 47.6080192],
    [11.8487549, 47.5802448],
    [11.6290283, 47.5858123],
    [11.5686035, 47.5116543],
    [11.2857056, 47.4039211],
    [11.1154175, 47.3927627],
    [10.9863281, 47.3983308],
    [10.8654785, 47.4912231],
    [10.579834, 47.5357548],
    [10.4534912, 47.5450412],
    [10.461731, 47.4281004],
    [10.3106689, 47.2847999],
    [10.1733398, 47.2699145],
    [10.178833, 47.2959917],
    [10.1980591, 47.3127535],
    [10.2200317, 47.3760508],
    [10.1760864, 47.3741782],
    [10.0909424, 47.3574372],
    [10.0909424, 47.4132335],
    [10.0662231, 47.4578286],
    [9.994812, 47.4893917],
    [9.9563599, 47.5301938],
    [9.876709, 47.5283253],
    [9.810791, 47.5579991],
    [9.7805786, 47.5839562],
    [9.6871948, 47.513495],
    [9.5059204, 47.5487224],
    [9.3328857, 47.6283909],
    [9.0829468, 47.6709453],
    [9.0252686, 47.6820373],
    [8.8796997, 47.6487316],
    [8.7918091, 47.713472],
    [8.7890625, 47.6709384],
    [8.6270142, 47.6894394],
    [8.6283875, 47.6792583],
    [8.6095047, 47.6695537],
    [8.5827255, 47.6603118],
    [8.5669327, 47.6649409],
    [8.5528564, 47.6684096],
    [8.5415268, 47.6563789],
    [8.536377, 47.6293073],
    [8.4855652, 47.6117195],
    [8.4951782, 47.579301],
    [8.3811951, 47.5598504],
    [8.210907, 47.6108046],
    [8.0831909, 47.557068],
    [7.9211426, 47.5468699],
    [7.8593445, 47.5820921],
    [7.7851868, 47.5487263],
    [7.6580286, 47.5300534],
    [7.5896645, 47.589841],
    [7.5891605, 47.5899095],
    [7.5247899, 47.6566601],
    [7.5113949, 47.6993683],
    [7.5542888, 47.8780918],
    [7.5664312, 48.0329053],
    [7.5810063, 48.1227528],
    [7.7144811, 48.3490034],
    [7.8031254, 48.5869271],
    [7.8546131, 48.6460314],
    [7.9738319, 48.7590745],
    [8.068825, 48.8174472],
    [8.1972063, 48.9627016],
    [8.0225623, 49.002048],
    [7.6469994, 49.0427348],
    [7.5063121, 49.0926912],
    [7.4539769, 49.1549555],
    [7.401309, 49.1713511],
    [7.3572564, 49.1395652],
    [7.2912633, 49.1049353],
    [7.1972895, 49.1091355],
    [7.1029294, 49.1311838],
    [7.0397258, 49.1002783],
    [7.017391, 49.1835793],
    [6.9474792, 49.2004264],
    [6.8884277, 49.2045886],
    [6.8620589, 49.1772148],
    [6.8458343, 49.1510206],
    [6.7286915, 49.1626541],
    [6.7218089, 49.2171556],
    [6.6721237, 49.2811078],
    [6.5991676, 49.3643493],
    [6.5583551, 49.4160024],
    [6.4905059, 49.4593521],
    [6.4650015, 49.4664385],
    [6.4447508, 49.4677741],
    [6.4281097, 49.4768967],
    [6.4197654, 49.4764174],
    [6.4093644, 49.468869],
    [6.3953747, 49.4646713],
    [6.3800066, 49.46654],
    [6.3726349, 49.466618],
    [6.3715985, 49.4686357],
    [6.3677251, 49.4693891],
    [6.3688302, 49.4704667],
    [6.3479143, 49.58192],
    [6.4838701, 49.7809592],
    [6.3164628, 49.8392176],
    [6.1472958, 49.975379],
    [6.1094338, 50.0637406],
    [6.1276835, 50.1313185],
    [6.1440984, 50.1345543],
    [6.1507235, 50.1463659],
    [6.132542, 50.153428],
    [6.1433794, 50.1559234],
    [6.1402292, 50.1697466],
    [6.1511542, 50.1784767],
    [6.1850763, 50.1808969],
    [6.1825923, 50.2008975],
    [6.1656113, 50.2207679],
    [6.2087179, 50.2540035],
    [6.2752537, 50.2697014],
    [6.2876249, 50.298522],
    [6.3195831, 50.322986],
    [6.3559225, 50.3108686],
    [6.4074633, 50.3315254],
    [6.3440101, 50.3798782],
    [6.3716067, 50.4430655],
    [6.3420974, 50.4626915],
    [6.3311451, 50.4885078],
    [6.2224807, 50.4961967],
    [6.1929101, 50.5202672],
    [6.1714269, 50.5557697],
    [6.2281246, 50.5896517],
    [6.2596795, 50.6190968],
    [6.1763025, 50.624418],
    [6.1252185, 50.7024513],
    [6.1205091, 50.7150948],
    [6.0464579, 50.726807],
    [6.0387553, 50.7183317],
    [6.0319747, 50.7299484],
    [6.0391821, 50.7426821],
    [6.0281059, 50.747641],
    [6.0218811, 50.7538347],
    [6.0195623, 50.7545635],
    [6.0249496, 50.812555],
    [6.0799456, 50.8488261],
    [6.0964948, 50.9196133],
    [6.0326099, 50.9793209],
    [5.908708, 51.002643],
    [5.9037673, 51.0535686],
    [5.9442794, 51.0325998],
    [5.9701788, 51.0434615],
    [6.0065711, 51.0820266],
    [6.1820251, 51.1526475],
    [6.1785543, 51.1958349],
    [6.0847521, 51.1953475],
    [6.2347627, 51.3560617],
    [6.2153703, 51.5138705],
    [6.0979056, 51.6091025],
    [6.1241484, 51.6550796],
    [6.0432664, 51.6748547],
    [6.0493577, 51.7179062],
    [5.999144, 51.7379612],
    [5.9845018, 51.8263626],
    [6.0726929, 51.8484746],
    [6.1620533, 51.8391021],
    [6.2122536, 51.8635798],
    [6.3214087, 51.8457274],
    [6.4057052, 51.8268665],
    [6.5904021, 51.8890839],
    [6.7236811, 51.8971781],
    [6.848833, 51.9723042],
    [6.7562217, 52.028855],
    [6.7057157, 52.0594702],
    [6.8597227, 52.1210494],
    [6.9749451, 52.1874047],
    [7.0746535, 52.2420314],
    [7.0797282, 52.3572233],
    [7.0582223, 52.4013061],
    [6.9879431, 52.4730437],
    [6.7420703, 52.4812905],
    [6.8138462, 52.6424971],
    [7.0542794, 52.6245385],
    [7.0975971, 52.8392215],
    [7.1862602, 52.9446427],
    [7.2210377, 53.0088898],
    [7.2246373, 53.1827837],
    [7.1520996, 53.325324],
    [6.9565988, 53.3498853],
    [6.8716264, 53.4622481],
    [6.3681436, 53.7073132],
  ],

  type: "LineString",
};

const pol_europe = {
  coordinates: [
    [-10.4836048, 38.822591],
    [-20.8601086, 55.8753108],
    [-26.1362969, 66.7225413],
    [-11.7147154, 67.7427591],
    [-3.272814, 62.5933408],
    [4.8173415, 62.5933408],
    [14.6662265, 70.0205873],
    [29.263681, 71.8014103],
    [31.9043886, 70.3926061],
    [30.959358, 69.5460384],
    [29.0242398, 68.9741636],
    [28.7554788, 68.318146],
    [29.9447073, 67.8092445],
    [30.1205803, 67.6092206],
    [29.329152, 66.9644763],
    [30.252485, 65.6763815],
    [31.8353415, 63.0350393],
    [27.9663201, 59.756395],
    [28.4499707, 59.4450751],
    [28.4939389, 56.1210604],
    [24.4928294, 53.1204053],
    [24.1850517, 51.3717804],
    [24.3158102, 50.4854735],
    [22.9967631, 48.4874865],
    [26.5746268, 48.3416462],
    [26.893206, 48.249369],
    [27.0785795, 48.1211843],
    [27.3220868, 47.872144],
    [28.4910333, 46.4454275],
    [29.8430565, 45.3367019],
    [28.4616275, 42.0329743],
    [26.0873427, 40.3632883],
    [25.6705844, 38.8910328],
    [28.3086786, 35.6751474],
    [27.4073297, 33.8886575],
    [12.1476581, 35.1019341],
    [10.5648016, 38.4793947],
    [-4.7361447, 35.6751474],
    [-9.1329684, 35.5322262],
    [-10.539952, 38.4793947],
  ],
  type: "LineString",
};


// UK + Ireland. Southern edge = the IDENTICAL Channel chain from
// pol_fr_rough (east->west, from the FR/BE sea corner at Dunkirk to Ushant):
// getCountryCode checks "fr" BEFORE "bi", so the shared sea border must use
// the same coordinate chain on both sides (tessellation rule, like BE/DE and
// FR/ES). Then a rough Atlantic sweep around Ireland, the Hebrides and
// Shetland, and down the North Sea (staying west of pol_sc_rough's west
// edge). Faroe Islands are deliberately OUTSIDE (they are not UK/IE — they
// fall back to foreca "eu"). Note: Shetland sits above the hr_bi data grid
// (dLatUL 60.0014) — geocoding says bi but the HR grid has no data there
// (pre-existing product limitation, unchanged by this polygon).
const pol_uk_rough = {
  coordinates: [
    [2.3425126, 51.2798369],
    [1.9101564, 51.1824502],
    [1.2062169, 50.8307703],
    [1.1662096, 50.1470964],
    [0.2735484, 49.9628714],
    [-0.1236427, 49.8044247],
    [-0.1903853, 49.5922974],
    [-0.9087225, 49.5957468],
    [-1.0404121, 49.8378164],
    [-1.4305474, 49.8658188],
    [-2.1348571, 49.8841831],
    [-2.1154761, 49.535765],
    [-1.8368085, 49.2553415],
    [-2.0057075, 48.9012893],
    [-2.4977324, 48.9530856],
    [-2.6107446, 49.2242122],
    [-2.9267377, 49.2900342],
    [-3.071355, 49.2781647],
    [-5.3140749, 48.6303559],
    [-5.3421595, 48.3752949],
    [-7.2070313, 50.3458631],
    [-4.9658203, 52.456167],
    [-5.8007813, 53.618561],
    [-5.8392334, 53.8670658],
    [-6.1495972, 54.0561757],
    [-6.285553, 54.1117489],
    [-6.3061523, 54.1057108],
    [-6.3178253, 54.0916155],
    [-6.3404846, 54.0952363],
    [-6.3356781, 54.10772],
    [-6.3457203, 54.1123269],
    [-6.3500547, 54.112981],
    [-6.3545609, 54.1104142],
    [-6.365118, 54.1137105],
    [-6.3665771, 54.072266],
    [-6.394043, 54.0593742],
    [-6.4421082, 54.056957],
    [-6.4709473, 54.062601],
    [-6.6178894, 54.0376012],
    [-6.6714478, 54.0698582],
    [-6.6577148, 54.1230186],
    [-6.6329956, 54.1535912],
    [-6.6563416, 54.1841438],
    [-6.7044067, 54.1969992],
    [-6.7250061, 54.1833349],
    [-6.7401123, 54.1801234],
    [-6.7524719, 54.1921605],
    [-6.771698, 54.198588],
    [-6.8128967, 54.2250953],
    [-6.8843079, 54.2820671],
    [-6.8582153, 54.3093162],
    [-6.8815613, 54.3453592],
    [-7.03125, 54.419733],
    [-7.1040344, 54.3565672],
    [-7.1754456, 54.3277374],
    [-7.1411133, 54.2515734],
    [-7.1479797, 54.2218792],
    [-7.1836853, 54.2194733],
    [-7.2331238, 54.2050148],
    [-7.2372437, 54.1720636],
    [-7.281189, 54.1189661],
    [-7.3210144, 54.1141416],
    [-7.3924255, 54.1213881],
    [-7.441864, 54.1455313],
    [-7.4761963, 54.1213845],
    [-7.5476074, 54.1189722],
    [-7.7233887, 54.2026255],
    [-7.8153992, 54.2050246],
    [-7.8717041, 54.2186722],
    [-7.8771973, 54.2900884],
    [-7.9541016, 54.306112],
    [-8.0007935, 54.347764],
    [-8.0557251, 54.3637686],
    [-8.1065369, 54.4117578],
    [-8.1587219, 54.4421315],
    [-8.1724548, 54.4692273],
    [-8.0845642, 54.4907781],
    [-8.0090332, 54.5449719],
    [-7.8291321, 54.54815],
    [-7.8016663, 54.5847823],
    [-7.6931763, 54.6110378],
    [-7.7178955, 54.6245559],
    [-7.776947, 54.6166011],
    [-7.8552246, 54.6277359],
    [-7.9156494, 54.6746224],
    [-7.9211426, 54.6968499],
    [-7.8387451, 54.7349269],
    [-7.7824402, 54.7206148],
    [-7.7522278, 54.7103364],
    [-7.6396179, 54.749167],
    [-7.5544739, 54.751542],
    [-7.5489807, 54.7895755],
    [-7.5297546, 54.8085745],
    [-7.4858093, 54.8291494],
    [-7.4514771, 54.8686888],
    [-7.4555969, 54.8923907],
    [-7.4473572, 54.9287108],
    [-7.4308777, 54.9484335],
    [-7.4047852, 54.9452756],
    [-7.4102783, 54.9839158],
    [-7.408905, 55.0051866],
    [-7.3869324, 55.025661],
    [-7.3553467, 55.0437521],
    [-7.2619629, 55.0688672],
    [-6.9735718, 55.1984295],
    [-6.7153931, 55.2790814],
    [-6.6796875, 55.4477079],
    [-6.9433594, 55.646526],
    [-8.3496094, 57.4213],
    [-7.5585938, 58.6540039],
    [-5.3173828, 59.7119355],
    [-3.8671875, 59.4671662],
    [-1.40625, 61.14342],
    [0.266055, 61.2266351],
    [1.7, 58.6],
    [2.35, 55.5],
    [2.443978, 52.6430634],
  ],

  type: "LineString",
};

const pol_be_rough = {
  coordinates: [

   [
        6.3648605,
        49.4690165
      ],
      [
        6.26214,
        49.5168209
      ],
      [
        5.8062744,
        49.5786644
      ],
      [
        5.0726151,
        49.7891194
      ],
      [
        4.8803544,
        50.1530225
      ],
      [
        4.6935868,
        50.1495026
      ],
      [
        4.6496415,
        50.0155576
      ],
      [
        4.3200517,
        49.9979054
      ],
      [
        4.1662431,
        50.314654
      ],
      [
        3.7377763,
        50.3952644
      ],
      [
        3.627913,
        50.514177
      ],
      [
        3.325789,
        50.5525847
      ],
      [
        3.1555009,
        50.8136227
      ],
      [
        2.8478837,
        50.7476304
      ],
      [
        2.3425126,
        51.2798369
      ],
      [
        3.081665,
        51.5702414
      ],
      [
        3.3556366,
        51.3743522
      ],
      [
        3.3583832,
        51.315593
      ],
      [
        3.3776093,
        51.2769511
      ],
      [
        3.4449005,
        51.2412858
      ],
      [
        3.5279846,
        51.2455843
      ],
      [
        3.5163116,
        51.2859704
      ],
      [
        3.581543,
        51.2876882
      ],
      [
        3.5952759,
        51.3022867
      ],
      [
        3.7875366,
        51.2473035
      ],
      [
        3.7899399,
        51.2118303
      ],
      [
        3.8853836,
        51.2008603
      ],
      [
        3.9605713,
        51.2163466
      ],
      [
        4.0594482,
        51.2438649
      ],
      [
        4.1679382,
        51.2902647
      ],
      [
        4.2420959,
        51.3520583
      ],
      [
        4.2269897,
        51.3734949
      ],
      [
        4.3347931,
        51.3777811
      ],
      [
        4.3402863,
        51.3580616
      ],
      [
        4.4316101,
        51.3627779
      ],
      [
        4.4316101,
        51.3752094
      ],
      [
        4.3938446,
        51.4210484
      ],
      [
        4.4007111,
        51.453579
      ],
      [
        4.5222473,
        51.4809553
      ],
      [
        4.5346069,
        51.4231893
      ],
      [
        4.6671295,
        51.4249019
      ],
      [
        4.7673798,
        51.502759
      ],
      [
        4.836731,
        51.4728297
      ],
      [
        4.7660065,
        51.4304675
      ],
      [
        4.7701263,
        51.4146251
      ],
      [
        4.7886658,
        51.4086293
      ],
      [
        4.9198151,
        51.3944931
      ],
      [
        5.0042725,
        51.4437367
      ],
      [
        5.0440979,
        51.4715465
      ],
      [
        5.1031494,
        51.4317518
      ],
      [
        5.0708771,
        51.3944931
      ],
      [
        5.1347351,
        51.3177388
      ],
      [
        5.1622009,
        51.3117303
      ],
      [
        5.2363586,
        51.3048624
      ],
      [
        5.2267456,
        51.2687892
      ],
      [
        5.2349854,
        51.2619149
      ],
      [
        5.4190063,
        51.2610555
      ],
      [
        5.5110168,
        51.2936999
      ],
      [
        5.5577087,
        51.2249478
      ],
      [
        5.8145142,
        51.1190409
      ],
      [
        5.6387329,
        50.8579767
      ],
      [
        5.6510925,
        50.8267585
      ],
      [
        5.6936646,
        50.8059347
      ],
      [
        5.6826782,
        50.7573099
      ],
      [
        6.0218811,
        50.7538347
      ],
      [
        6.0218811,
        50.7538347
      ],
      [
        6.0281059,
        50.747641
      ],
      [
        6.0391821,
        50.7426821
      ],
      [
        6.0319747,
        50.7299484
      ],
      [
        6.0387553,
        50.7183317
      ],
      [
        6.0464579,
        50.726807
      ],
      [
        6.1205091,
        50.7150948
      ],
      [
        6.1252185,
        50.7024513
      ],
      [
        6.1763025,
        50.624418
      ],
      [
        6.2596795,
        50.6190968
      ],
      [
        6.2281246,
        50.5896517
      ],
      [
        6.1714269,
        50.5557697
      ],
      [
        6.1929101,
        50.5202672
      ],
      [
        6.2224807,
        50.4961967
      ],
      [
        6.3311451,
        50.4885078
      ],
      [
        6.3420974,
        50.4626915
      ],
      [
        6.3716067,
        50.4430655
      ],
      [
        6.3440101,
        50.3798782
      ],
      [
        6.4074633,
        50.3315254
      ],
      [
        6.3559225,
        50.3108686
      ],
      [
        6.3195831,
        50.322986
      ],
      [
        6.2876249,
        50.298522
      ],
      [
        6.2752537,
        50.2697014
      ],
      [
        6.2087179,
        50.2540035
      ],
      [
        6.1656113,
        50.2207679
      ],
      [
        6.1825923,
        50.2008975
      ],
      [
        6.1850763,
        50.1808969
      ],
      [
        6.1511542,
        50.1784767
      ],
      [
        6.1402292,
        50.1697466
      ],
      [
        6.1433794,
        50.1559234
      ],
      [
        6.132542,
        50.153428
      ],
      [
        6.1507235,
        50.1463659
      ],
      [
        6.1440984,
        50.1345543
      ],
      [
        6.1276835,
        50.1313185
      ],
      [
        6.1276835,
        50.1313185
      ],
      [
        6.1094338,
        50.0637406
      ],
      [
        6.1472958,
        49.975379
      ],
      [
        6.3164628,
        49.8392176
      ],
      [
        6.4838701,
        49.7809592
      ],
      [
        6.3479143,
        49.58192
      ],
      [
        6.3688302,
        49.4704667
      ]

  ],
  type: "LineString"
}

// Scandinavia region: Norway, Sweden, Finland + Denmark + the three Baltic
// states. South edge SHARES pol_de_rough's sea/top chain: the ring starts at
// DE's north-west sea corner [7.932,55.179] and closes along DE's own
// [14.326,54.636]->[7.932,55.179] segment (getCountryCode checks "de" BEFORE
// "sc", so the shared edge must be identical — tessellation rule). Northern
// Norway and the whole FI/RU + Baltic/RU eastern border REUSE the
// pol_europe chain (sc is checked before eu, identical chain -> tessellate).
// Known accepted quirks (asserted in diag_polygon_regions.mjs):
// - Lolland/Falster (DK islands south of DE's straight top line) stay "de"
//   until pol_de_rough's top edge is refined (out of scope here);
// - Kaliningrad (RU) falls inside sc (kept for point economy);
// - the sliver west of lng 4.003 is outside the hr_sc data grid — sea only.
const pol_sc_rough = {
  coordinates: [
    [8.0310059, 55.0972111],
    [6.9, 56.6],
    [6.5, 57.9],
    [4.7, 58.7],
    [3.8782884, 61.5946395],
    [9.8579492, 67.5998026],
    [14.6662265, 70.0205873],
    [29.263681, 71.8014103],
    [31.9043886, 70.3926061],
    [30.959358, 69.5460384],
    [29.0242398, 68.9741636],
    [28.7554788, 68.318146],
    [29.9447073, 67.8092445],
    [30.1205803, 67.6092206],
    [29.329152, 66.9644763],
    [30.252485, 65.6763815],
    [31.7724609, 62.8149668],
    [29.53125, 61.3967189],
    [27.9663201, 59.756395],
    [28.223877, 59.4003546],
    [27.8173828, 57.862376],
    [28.3007813, 56.2433887],
    [27.6306152, 55.7580027],
    [26.62, 55.68],
    [26.85, 55.32],
    [26.7297363, 55.1537899],
    [25.7958984, 54.8640522],
    [25.7299805, 54.110899],
    [25.0927734, 54.130302],
    [24.4, 53.85],
    [23.45, 53.9],
    [23.3239746, 54.2395777],
    [22.75, 54.35],
    [22.6977539, 54.6293412],
    [22.9284668, 54.88293],
    [20.6542969, 55.3855148],
    [18.6108398, 55.0218609],
    [14.3261719, 54.6356973],
    [13.3044434, 54.8577215],
    [11.9970703, 54.3805016],
    [11.3269043, 54.5975249],
    [10.5358887, 54.5847383],
    [9.8245239, 54.819675],
    [9.6350098, 54.8370767],
    [9.6075439, 54.8856905],
    [9.4866943, 54.8434044],
    [9.4303894, 54.827191],
    [9.4091034, 54.8423216],
    [9.3768311, 54.837086],
    [9.3754578, 54.8216573],
    [9.3411255, 54.8014755],
    [9.2504883, 54.8070089],
    [9.2422485, 54.8513153],
    [9.0802002, 54.8687048],
    [8.9208984, 54.9034703],
    [8.7451172, 54.8987389],
    [8.555603, 54.9192499],
    [8.4512329, 55.0626463],
  ],

  type: "LineString",
};

const pol_es_rough = {
  coordinates: [

    // FR/ES border: identical chain as in pol_fr_rough (west->east).
    // getCountryCode checks "fr" BEFORE "ip", so any overlap resolves to
    // France — shared borders must use identical coordinate chains on both
    // sides (same rule as the BE/DE border).
    [
      -1.8077472, 43.5528715
    ],
    [
      -1.7816042, 43.3448897
    ],
    [
      -1.7310372, 43.2963004
    ],
    [
      -1.6540185, 43.2977528
    ],
    [
      -1.6141838, 43.2569244
    ],
    [
      -1.571118, 43.2454997
    ],
    [
      -1.4443697, 43.260417
    ],
    [
      -1.3870789, 43.2169286
    ],
    [
      -1.4764191, 43.0974655
    ],
    [
      -1.4399958, 43.0425629
    ],
    [
      -1.3634608, 43.0286904
    ],
    [
      -1.275965, 43.0364465
    ],
    [
      -0.9035296, 42.9426012
    ],
    [
      -0.7498271, 42.9575218
    ],
    [
      -0.7232793, 42.887395
    ],
    [
      -0.541962, 42.7813385
    ],
    [
      -0.2656247, 42.8193761
    ],
    [
      -0.0184593, 42.6844308
    ],
    [
      0.1543431, 42.7176251
    ],
    [
      0.2932201, 42.671574
    ],
    [
      0.6734626, 42.6904008
    ],
    [
      0.7251561, 42.8496431
    ],
    [
      0.9441308, 42.7829921
    ],
    [
      1.0513884, 42.7772043
    ],
    [
      1.1803427, 42.7047043
    ],
    [
      1.3434905, 42.6968196
    ],
    [
      1.4444826, 42.604913
    ],
    [
      1.5163753, 42.6501218
    ],
    [
      1.5852481, 42.6356557
    ],
    [
      1.7058619, 42.6204679
    ],
    [
      1.7398377, 42.5901521
    ],
    [
      1.7311439, 42.4923921
    ],
    [
      1.9370533, 42.4291961
    ],
    [
      1.9690061, 42.374394
    ],
    [
      2.0131074, 42.343473
    ],
    [
      2.0829239, 42.3609579
    ],
    [
      2.1237904, 42.383215
    ],
    [
      2.1525377, 42.4169817
    ],
    [
      2.1825178, 42.4185896
    ],
    [
      2.206831, 42.4166946
    ],
    [
      2.2552235, 42.4328269
    ],
    [
      2.2908935, 42.4203598
    ],
    [
      2.3463288, 42.4055136
    ],
    [
      2.4291463, 42.3833477
    ],
    [
      2.4332401, 42.3775088
    ],
    [
      2.4793873, 42.3392541
    ],
    [
      2.5412887, 42.3335697
    ],
    [
      2.5574098, 42.3466607
    ],
    [
      2.5752356, 42.3543935
    ],
    [
      2.6217025, 42.3431042
    ],
    [
      2.6573841, 42.3395535
    ],
    [
      2.676418, 42.3421328
    ],
    [
      2.6720571, 42.3874348
    ],
    [
      2.6731414, 42.3999125
    ],
    [
      2.7547465, 42.4197202
    ],
    [
      2.7679183, 42.4055512
    ],
    [
      2.7849369, 42.4136332
    ],
    [
      2.8456594, 42.4522562
    ],
    [
      2.8975933, 42.4582861
    ],
    [
      2.9464829, 42.4651088
    ],
    [
      3.0372939, 42.4646101
    ],
    [
      3.0728321, 42.431162
    ],
    [
      3.1729153, 42.4327141
    ],
    [
      3.4473937, 42.4358419
    ],
    // sea closure: Mediterranean -> Gibraltar -> Atlantic/Portugal -> Biscay
    [
      4.594736, 41.781088
    ],
    [
      4.353036, 38.781436
    ],
    [
      -2.411065, 35.86046
    ],
    [
      -11.218728, 35.91447
    ],
    [
      -10.237048, 44.160899
    ]

  ],
  type: "LineString"
}